import {css} from 'lit';
export const styles = css``;
export default styles;
